import useTeams from "./useTeams";
import ListingCardWrapper from "../listingCard/ListingCardWrapper";
import ListingCardPagination from "../listingCard/ListingCardPagination";
import ListingCardHeader from "../listingCard/ListingCardHeader";
import ListingCardTable from "../listingCard/ListingCardTable";
import TeamForm from "./TeamForm";
import XButton from "../common/XButton";
import { rowActionCellClasses } from "../common/caseListClasses";

// Squares off the chip when it carries an icon with no label beside it.
const iconOnlyRowActionClasses = "w-8 px-0!";

const Teams = ({ classNames }) => {
    const {
        handleSearchChange,
        openModal,
        handleEdit,
        handleDelete,
        teamsList,
        limit,
        setLimit,
        totalCount,
        totalPages,
        currentPage,
        setCurrentPage,
        isShowModal, closeModal,
        isFormSubmitting,
        onSubmit,
        selectedTeam
    } = useTeams();

    const tableHeaders = [
        {
            label: 'Name',
            field: 'name',
            sortKey: 'name',
        },
        {
            label: 'Description',
            field: 'description',
            sortKey: 'description',
        },
        {
            label: 'Actions',
            field: 'actions',
            sortKey: null,
            render: (team) => (
                <div className={rowActionCellClasses}>
                    <XButton variant="rowAction" onClick={() => handleEdit(team)}>
                        <i className="fa-solid fa-pen"></i> Edit
                    </XButton>
                    <XButton
                        variant="rowAction"
                        className={iconOnlyRowActionClasses}
                        onClick={() => handleDelete(team)}
                        aria-label="Delete team"
                    >
                        <i className="fa-solid fa-trash"></i>
                    </XButton>
                </div>
            )
        }
    ];

    return (
        <div className={`${classNames}`}>
            <ListingCardWrapper>
                <ListingCardHeader
                    title={'Teams'}
                    handleSearchChange={handleSearchChange}
                    btnText={'Add Team'}
                    onBtnClick={openModal}
                />

                <ListingCardTable
                    tableHeaders={tableHeaders}
                    list={teamsList}
                    defaultSortConfigKey={'name'}
                />

                <ListingCardPagination
                    dataLimit={limit}
                    setDataLimit={setLimit}
                    totalCount={totalCount}
                    totalPages={totalPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />

                {isShowModal && (
                    <TeamForm
                        isOpen={isShowModal}
                        onClose={closeModal}
                        isFormSubmitting={isFormSubmitting}
                        onSubmit={onSubmit}
                        selectedTeam={selectedTeam}
                    />
                )}
            </ListingCardWrapper>
        </div>
    )
}

export default Teams;